import api from './api';

/**
 * Fetch electricity power cost calculation data from the backend API.
 * @param {Object} params
 * @param {number} params.year - Target year (e.g. 2026)
 * @param {number|string} [params.month] - Target billing cycle month (1-12) or 'all'
 * @param {number} [params.day=15] - Meter reading day of the month (1-31)
 * @param {string} [params.zone] - Filter by zone, or omitted for whole house
 * @param {number} [params.ftRate=0.1623] - Fuel adjustment charge rate per unit
 * @returns {Promise<Array>} Array of power cost records
 */
export const getPowerCost = async ({
    year,
    month,
    day = 15,
    zone,
    ftRate = 0.1623,
} = {}) => {
    const params = {};

    if (year !== undefined && year !== null && year !== '') {
        params.year = parseInt(year, 10);
    }
    if (month !== undefined && month !== null && month !== '' && month !== 'all') {
        params.month = parseInt(month, 10);
    }
    if (day !== undefined && day !== null && day !== '') {
        params.day = parseInt(day, 10);
    }
    if (zone !== undefined && zone !== null && zone !== '' && zone !== 'all') {
        params.zone = zone;
    }
    if (ftRate !== undefined && ftRate !== null && !isNaN(ftRate)) {
        params.ftRate = parseFloat(ftRate);
    }

    const response = await api.get('/sensor/power-cost', { params });
    return response.data;
};

/**
 * Fetch available zones from the latest sensor data.
 * @returns {Promise<Array<string>>}
 */
export const getAvailableZones = async () => {
    try {
        const response = await api.get('/sensor/latest');
        const zones = [...new Set(response.data.map((item) => item.zone))]
            .filter(Boolean)
            .sort();
        return zones;
    } catch (err) {
        console.error('Failed to fetch available zones:', err);
        return [];
    }
};
